/**
 * Sets the margin on elements with a `contain-left` or `contain-right` css class,
 * so that they line up with bootstrap .container elements without being inside a container.
 *
 * To use padding instead of margin, add a `contain-with-padding` class.
 */
const setupContainerAligned = (): void =>
{
	const containers = document.querySelectorAll( '.contain-left, .contain-right' );

	if (containers.length) {

		const measureContainer = document.createElement( 'div' );

		measureContainer.id = 'container-aligned-measure';
		measureContainer.classList.add( 'container' );
		measureContainer.innerHTML = '<div></div>';

		document.body.appendChild( measureContainer );

		contain( containers );
		window.addEventListener( 'resize', () => contain( containers ) );
	}
};


/**
 *
 * @param {NodeListOf<HTMLElement>} containers
 */
const contain = ( containers: NodeListOf<Element> ): void =>
{
	const measure = document.querySelector( '#container-aligned-measure > div' );

	if (measure instanceof HTMLElement) {

		containers.forEach( container =>
		{
			if (container instanceof HTMLElement) {

				const usePadding = container.classList.contains( 'contain-with-padding' );
				const prop       = usePadding ? 'padding' : 'margin';

				if (container.classList.contains( 'contain-left' )) {
					container.style[`${prop}Left`] = `${measure.offsetLeft}px`;
				}

				if (container.classList.contains( 'contain-right' )) {
					container.style[`${prop}Right`] = `${measure.offsetLeft}px`;
				}
			}
		} );
	}
};


/**
 *
 */
export default setupContainerAligned;